export default "__VITE_ASSET__BjQ_pHng__"